import React, { PropsWithChildren, useMemo } from 'react'
import { Animated, ViewProps } from 'react-native'
import styled from 'styled-components/native'
import { useOnLayout } from 'APP/Hooks/Layout'
import { useBottomDrawer } from '../BottomDrawerProvider'

const Container = styled.View`
  background-color: ${({ theme }) => theme.colors.background};
  border-top-left-radius: ${({ theme }) => theme.metrics.borderRadius.medium}px;
  border-top-right-radius: ${({ theme }) => theme.metrics.borderRadius.medium}px;
  ${({ theme }) => theme.shadows.heavy};
`

type Props = PropsWithChildren & ViewProps

export const BottomDrawerContent = ({ children, ...rest }: Props) => {
  const { slideIn } = useBottomDrawer()

  const {
    layout: { height: modalHeight },
    onLayout: onModalLayout,
  } = useOnLayout()

  const animatedStyle = useMemo(
    () => ({
      transform: [
        {
          translateY: slideIn.interpolate({
            inputRange: [0, 1],
            outputRange: [modalHeight, 0],
          }),
        },
      ],
    }),
    [slideIn, modalHeight]
  )

  return (
    <Animated.View style={animatedStyle}>
      <Container onLayout={onModalLayout} {...rest}>
        {children}
      </Container>
    </Animated.View>
  )
}
